import { Tag } from '@cian/components';
import * as React from 'react';

import { ETenant } from '../../../../json_query';
import { ITenantsTag } from '../../../state/tags/definitions/tenants';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ITenantsTagItemProps {
  tag: ITenantsTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const tenantsMap = {
  [ETenant.Any]: 'любой',
  [ETenant.Family]: 'семья',
  [ETenant.Man]: 'мужчина',
  [ETenant.Woman]: 'женщина',
};

export const TenantsTagItem = ({ withNewTag, onDeleteClick, tag }: ITenantsTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Состав съёмщиков: {tenantsMap[tag.value]}
    </TagComponent>
  );
};
